import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.AppointmentContact,
  'contact',
  () => import('@/views/steps/ContactStep.vue'),
);

route.requiresAuthentication();
route.requiresPropertyStep();
route.requiresScheduleStep();
route.showSummarySidebar();

export default route.getRoute();
